// extracted by mini-css-extract-plugin
export default {"cartIconContainer":"BagIcon_cartIconContainer__6Fm5H","shoppingIcon":"BagIcon_shoppingIcon__Wu0Fp","itemCount":"BagIcon_itemCount__xsY9o"};